import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import { getValidIrrigationSchedulerEmitters } from './getValidIrrigationSchedulerEmitters'

export const getIrrigationProperties = (fass: TFieldAssetStoreState) =>
  Object.values(fass.properties ?? {}).filter(
    (p) => Object.keys(getValidIrrigationSchedulerEmitters(p.irrigationZoneEmitters)).length,
  )
